<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- userName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- privateNumber -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.privateNumber"></td-value>
        </td>

        <!-- organizationName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- smsCp -->
        <td>
          <span> {{ item?.smsCp | enumToText : SmsCpEnumValues }}</span>
        </td>

        <!-- sendTypesList -->
        <td
          class="msg-summary tw-text-center"
          [ngClass]="{
            ' tw-cursor-pointer': item?.sendTypesList
          }"
        >
          <div
            class="tw-flex-center"
            textPopover
            [parentSelector]="tagName"
            [fullText]="item?.sendTypesList"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.sendTypesList | checkValue }}
            </p>
          </div>
        </td>

        <!-- canSeeReceivedSms -->
        <td>
          <td-value type="boolean" [value]="item?.canSeeReceivedSms"></td-value>
        </td>
        <!-- sendToBlackList -->
        <td>
          <td-value type="boolean" [value]="item?.sendToBlackList"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
